// Design tokens do modal "Como funcionam os alertas".
// Mesma tinta/hairline do drawer de tarefa (TarefaDialog.design.js), em modal
// centrado: é conteúdo curto de leitura + dois controles, não um formulário.

export const AT = {
  // faixa de descoberta: alertas/participantes/lembrete são novos, ninguém
  // procura o que não sabe que existe. Dispensável, uma vez por usuário.
  strip:
    'mb-3 flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-2.5 rounded-[12px] border border-[#ddd6fe] dark:border-violet-500/20 bg-[#f5f3ff] dark:bg-violet-500/5',
  stripIcon: 'text-[#6d28d9] dark:text-violet-300 flex-shrink-0',
  stripText: 'text-[13px] text-[#3f3f46] dark:text-[#D1D2D3] flex-1 min-w-0',
  stripLink:
    'text-[13px] font-semibold text-[#6d28d9] dark:text-violet-300 hover:underline whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40 rounded',
  stripClose:
    'p-1 rounded-md text-[#a1a1aa] hover:text-[#6d28d9] hover:bg-[#ede9fe] dark:hover:bg-violet-500/15 transition-colors flex-shrink-0',

  // gatilho no cabeçalho da página
  trigger:
    'relative h-9 w-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-[#383838] bg-white dark:bg-[#222529] text-gray-500 dark:text-[#ABABAD] hover:text-[#7C3AED] hover:border-[#7C3AED]/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',
  triggerDot:
    'absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-[#7C3AED] ring-2 ring-white dark:ring-[#222529]',

  // z acima do drawer de tarefa (9999) e dos seus popovers (10000/10001):
  // o modal também abre a partir do drawer, e precisa ficar por cima.
  overlay:
    'fixed inset-0 z-[10002] flex items-center justify-center p-4 animate-in fade-in duration-200 motion-reduce:animate-none',
  backdrop: 'absolute inset-0 bg-black/40 backdrop-blur-[2px]',
  panel:
    'relative w-full max-w-2xl max-h-[85vh] flex flex-col bg-white dark:bg-[#222529] rounded-[16px] border border-[#e7e7ec] dark:border-[#383838] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200 motion-reduce:animate-none',

  header: 'flex items-start justify-between gap-4 px-6 py-5 border-b border-[#f0f0f3] dark:border-[#383838] flex-shrink-0',
  headerIcon:
    'flex items-center justify-center w-9 h-9 rounded-[10px] bg-[#ede9fe] text-[#6d28d9] dark:bg-violet-500/15 dark:text-violet-300 flex-shrink-0',
  title: 'text-[16px] font-semibold text-[#18181b] dark:text-[#D1D2D3]',
  subtitle: 'mt-0.5 text-[13px] text-[#71717a] dark:text-[#ABABAD]',
  close:
    'p-2 rounded-[10px] text-[#a1a1aa] hover:text-[#18181b] hover:bg-[#f4f4f5] dark:hover:bg-[#383838] dark:hover:text-[#D1D2D3] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',

  body: 'flex-1 overflow-y-auto px-6 py-5 space-y-6',
  sectionTitle: 'text-[13px] font-semibold text-[#18181b] dark:text-[#D1D2D3] mb-3',

  // ---------- canais (acionável) ----------
  channel:
    'flex items-center gap-3 p-3 rounded-[10px] border border-[#f0f0f3] dark:border-[#383838] bg-[#fafafb] dark:bg-[#1A1D21]',
  channelIcon: 'flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0',
  channelIconOn: 'bg-[#ecfdf3] text-[#067647] dark:bg-green-500/15 dark:text-green-300',
  channelIconOff: 'bg-[#f4f4f5] text-[#a1a1aa] dark:bg-[#383838] dark:text-[#6b6b6b]',
  channelName: 'text-[13px] font-medium text-[#18181b] dark:text-[#D1D2D3]',
  channelDesc: 'text-[12px] text-[#71717a] dark:text-[#ABABAD]',
  pill: 'text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0',
  pillOn: 'bg-[#ecfdf3] text-[#067647] dark:bg-green-500/15 dark:text-green-300',
  pillOff: 'bg-[#f4f4f5] text-[#71717a] dark:bg-[#383838] dark:text-[#ABABAD]',
  pillBlocked: 'bg-[#fef3f2] text-[#b42318] dark:bg-red-500/15 dark:text-red-300',
  channelBtn:
    'h-8 px-3 rounded-[8px] bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-[12px] font-semibold whitespace-nowrap flex-shrink-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',

  // ---------- eventos ----------
  eventList: 'divide-y divide-[#f0f0f3] dark:divide-[#383838] rounded-[10px] border border-[#f0f0f3] dark:border-[#383838] overflow-hidden',
  eventRow: 'flex items-center gap-3 px-3 py-2.5',
  eventIcon: 'w-4 h-4 flex-shrink-0 text-[#a1a1aa]',
  eventWhen: 'text-[13px] text-[#3f3f46] dark:text-[#D1D2D3] flex-1 min-w-0',
  eventMsg:
    'text-[12px] font-medium text-[#6d28d9] dark:text-violet-300 bg-[#f5f3ff] dark:bg-violet-500/10 px-2 py-0.5 rounded-md whitespace-nowrap flex-shrink-0',

  // ---------- duas colunas de contexto ----------
  cols: 'grid grid-cols-1 sm:grid-cols-2 gap-4',
  note: 'p-3.5 rounded-[10px] border border-[#f0f0f3] dark:border-[#383838]',
  noteTitle: 'text-[12px] font-semibold text-[#18181b] dark:text-[#D1D2D3] mb-2',
  noteItem: 'flex items-start gap-2 text-[12px] text-[#3f3f46] dark:text-[#ABABAD] leading-relaxed',
  noteDot: 'mt-[6px] w-1 h-1 rounded-full bg-[#a1a1aa] flex-shrink-0',

  footer:
    'flex items-center justify-between gap-3 px-6 py-4 border-t border-[#f0f0f3] dark:border-[#383838] bg-[#fafafb] dark:bg-[#1A1D21] flex-shrink-0',
  footerHint: 'text-[12px] text-[#71717a] dark:text-[#ABABAD]',
  primaryBtn:
    'h-9 px-4 rounded-[10px] bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-[13px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7C3AED]/40',
};
